import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import api from "../services/api";
import DistrictDrilldownChart from "../components/DistrictDrilldownChart";

import Chatbot from "../components/Chatbot";
export default function Home() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [chat, setChat] = useState("");
  const [chatReply, setChatReply] = useState("");

  const [openFAQ, setOpenFAQ] = useState(null);
  
  useEffect(() => {
    api
      .get("/dashboard/district?mode=cumulative")
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  /* FAQ DATA */

  const faqData = [
    {
      question: "बेटी जन्मोत्सव योजना क्या है?",
      answer:
        "यह योजना बालिका के जन्म को प्रोत्साहित करने और उसके सम्मान के लिए चलाई जाती है।",
    },

    {
      question: "इस योजना का लाभ किसे मिलेगा?",
      answer: "भोजपुर जिले में जन्मी बालिका इस योजना के लिए पात्र है।",
    },

    {
      question: "आवेदन कैसे करें?",
      answer:
        "आंगनवाड़ी केंद्र या सरकारी अस्पताल के माध्यम से आवेदन किया जा सकता है।",
    },

    {
      question: "आवश्यक दस्तावेज क्या हैं?",
      answer:
        "जन्म प्रमाण पत्र, माता-पिता का आधार कार्ड और स्थानीय निवास प्रमाण पत्र।",
    },

    {
      question: "योजना से क्या लाभ मिलेगा?",
      answer:
        "बालिका के जन्म पर सम्मान समारोह तथा सरकार द्वारा निर्धारित सहायता प्रदान की जाती है।",
    },

    {
      question: "अधिक जानकारी के लिए कहाँ संपर्क करें?",
      answer:
        "जिला परियोजना प्रबंधक, महिला एवं बाल विकास निगम,  भोजपुर तथा जिला महिला सशक्तिकरण कार्यालय, सदर प्रखंड परिसर, आरा से संपर्क कर सकते हैं।",
    },
  ];

  /* TOTAL BENEFICIARIES */

  const [totalBeneficiaries, setTotalBeneficiaries] = useState(0);

  return (
    <div className="min-h-screen bg-indigo-50">
      <Navbar />
      
      <div className="max-w-7xl mx-auto p-8">
        {/* HEADER */}

        <div className="mb-12 bg-white shadow-xl rounded-xl p-8 border-t-4 border-indigo-600">

  <div className="grid grid-cols-3 items-center">

    {/* CM PHOTO */}
    <div className="flex flex-col items-center">
      <img
        src="/samrat_choudhary.jpeg"
        alt="Chief Minister"
        className="w-24 h-24 object-cover rounded-full shadow-md border-4 border-indigo-200"
      />
      <p className="text-sm font-semibold mt-2 text-gray-700">
        माननीय मुख्यमंत्री
      </p>
      <p className="text-xs text-gray-500">बिहार</p>
    </div>

    {/* CENTER LOGOS */}
    <div className="text-center">
      <div className="flex justify-center items-center gap-6 mb-4">
        <img
          src="/Beti_Bachao_Beti_Padhao_logo.jpg"
          className="w-20"
        />

        <img
          src="/bihar-logo.jpg"
          className="w-24"
        />

        <img
          src="/bal bikas nigam logo.jpg"
          className="w-20"
        />
      </div>

      <h1 className="text-4xl font-bold text-indigo-700">
        बेटी जन्मोत्सव
      </h1>

      <p className="text-lg font-semibold text-gray-700">
        कन्या रत्न सम्मान अभियान
      </p>

      <p className="text-gray-500">
        महिला एवं बाल विकास निगम, भोजपुर (आरा)
      </p>
    </div>

    {/* DM PHOTO */}
    <div className="flex flex-col items-center">
      <img
        src="/dm-bhojpur.jpg"
        alt="District Magistrate"
        className="w-24 h-24 object-cover rounded-full shadow-md border-4 border-green-200"
      />
      <p className="text-sm font-semibold mt-2 text-gray-700">
        जिला पदाधिकारी
      </p>
      <p className="text-xs text-gray-500">भोजपुर</p>
    </div>

  </div>

</div>

        {/* APP MESSAGE */}

        <div className="max-w-7xl mx-auto mt-6 px-8">
  <div className="grid md:grid-cols-2 gap-6">

    {/* DM MESSAGE */}
    <div className="bg-white shadow-lg rounded-xl border overflow-hidden">
      
      <div className="bg-indigo-600 text-white px-6 py-3 font-semibold text-lg">
        जिला पदाधिकारी का संदेश
      </div>

      <div className="p-6 text-gray-700 leading-relaxed">
        <p className="mb-3">
          प्रिय भोजपुर वासियों,
          बेटीयां हमारे समाज की शक्ति, सम्मान और भविष्य की आधारशिला है । जिला प्रशासन,
          भोजपुर के नवाचार योजना ‘बेटी जन्मोत्सव – कन्या रत्न अभियान’ का मुख्य उद्देश्य
          जिला अंतर्गत संस्थागत प्रसव से जन्म लेने वाली सभी बेटीयों के जन्म को उत्सव
          के रूप में मनाना एवं उनके परिवार को 25 जनकल्याणकारी योजनाओं से लाभान्वित
          करते हुए समान अधिकार एवं अवसर प्रदान करना है ।
        </p>

        <ul className="list-disc pl-5 space-y-1 mb-4">
          <li>बेटी के जन्म पर खुशियाँ मनाएँ, भेदभाव न करें</li>
          <li>बेटियों को शिक्षा, स्वास्थ्य और सुरक्षा का पूरा अधिकार दें</li>
          <li>भ्रूण हत्या, दहेज प्रथा, बाल विवाह जैसी कुरीतियों को समाप्त करें</li>
        </ul>

        <p>
          आइए, हम सब मिलकर यह संकल्प लें कि हर बेटी सुरक्षित, शिक्षित एवं सशक्त बने ।
        </p>

        <div className="mt-6 text-right font-semibold text-indigo-700">
          — जिला पदाधिकारी, भोजपुर
        </div>
      </div>
    </div>

    {/* DDC MESSAGE */}
    <div className="bg-white shadow-lg rounded-xl border overflow-hidden">
      
      <div className="bg-green-600 text-white px-6 py-3 font-semibold text-lg">
        उप विकास आयुक्त का संदेश
      </div>

      <div className="p-6 text-gray-700 leading-relaxed">
        <p className="mb-3">
          प्रिय भोजपुर वासियों,
          "बेटी जन्मोत्सव कन्या रत्न अभियान" के अवसर पर मैं आप सभी से अपील करती हूं
          कि बेटियों के जन्म को उत्सव की तरह मनाएं । बेटियां हमारे समाज की उज्ज्वल
          भविष्य हैं, उनका सम्मान और सुरक्षा हमारी जिम्मेदारी है ।
        </p>

        <ul className="list-disc pl-5 space-y-1">
          <li>बेटी की शिक्षा और स्वास्थ्य को प्राथमिकता बनाएं</li>
          <li>उन्हें आत्मनिर्भर एवं आत्मविश्वासी बनने में सहयोग करें</li>
          <li>बेटी को बोझ नहीं, बल्कि गौरव और सम्मान समझें</li>
        </ul>

        <div className="mt-6 text-right font-semibold text-green-700">
          — उप विकास आयुक्त, भोजपुर
        </div>
      </div>
    </div>

  </div>
</div>
        {/* ABOUT SCHEME */}

        <div className="bg-white shadow-md rounded-lg p-6 mt-10 mb-10 border-l-4 border-indigo-600">
  <h2 className="text-2xl font-bold mb-4 text-indigo-700">
    योजना का उद्देश्य
  </h2>

  <ul className="list-decimal pl-6 text-gray-700 space-y-2 leading-relaxed">
    <li>बालिकाओं के जन्म को प्रोत्साहित करना, लिंगानुपात में सुधार</li>

    <li>
      बेटी एवं उनके परिवार को केंद्र एवं राज्य सरकार द्वारा संचालित 25
      जन कल्याणकारी योजनाओं से लाभान्वित करना
    </li>

    <li>जन कल्याणकारी योजनाओं का जागरूकता फैलाना</li>
  </ul>
</div>
      {/* DISTRICT MONITORING TEAM */}

<div className="bg-white shadow-lg rounded-lg p-6 mb-10 border-t-4 border-indigo-600">
  <h2 className="text-2xl font-bold mb-4 text-indigo-700 text-center">
    जिला स्तरीय मॉनिटरिंग टीम
  </h2>

  <div className="overflow-auto">
    <table className="min-w-full text-sm border">
      <thead className="bg-indigo-100">
        <tr>
          <th className="border p-2">क्रम संख्या</th>
          <th className="border p-2">पदाधिकारी का पदनाम</th>
          <th className="border p-2">विभाग</th>
          <th className="border p-2">संपर्क संख्या</th>
        </tr>
      </thead>

      <tbody>
        <tr className="hover:bg-gray-50">
          <td className="border p-2 text-center">01</td>
          <td className="border p-2">जिला प्रोग्राम पदाधिकारी</td>
          <td className="border p-2">आई०सी०डी०एस०</td>
          <td className="border p-2"></td>
        </tr>

        <tr className="hover:bg-gray-50">
          <td className="border p-2 text-center">02</td>
          <td className="border p-2">GM, DIC</td>
          <td className="border p-2">उद्योग</td>
          <td className="border p-2"></td>
        </tr>

        <tr className="hover:bg-gray-50">
          <td className="border p-2 text-center">03</td>
          <td className="border p-2">जिला परियोजना प्रबंधक</td>
          <td className="border p-2">जीविका</td>
          <td className="border p-2"></td>
        </tr>

        <tr className="hover:bg-gray-50">
          <td className="border p-2 text-center">04</td>
          <td className="border p-2">जिला कार्यक्रम प्रबंधक</td>
          <td className="border p-2">स्वास्थ्य</td>
          <td className="border p-2"></td>
        </tr>

        <tr className="hover:bg-gray-50">
          <td className="border p-2 text-center">05</td>
          <td className="border p-2">जिला परियोजना प्रबंधक</td>
          <td className="border p-2">WCDC</td>
          <td className="border p-2"></td>
        </tr>

        <tr className="hover:bg-gray-50">
          <td className="border p-2 text-center">06</td>
          <td className="border p-2">प्रबंधक</td>
          <td className="border p-2">DRCC</td>
          <td className="border p-2"></td>
        </tr>

        <tr className="hover:bg-gray-50">
          <td className="border p-2 text-center">07</td>
          <td className="border p-2">
            बाल विकास परियोजना पदाधिकारी, आरा ग्रामीण
          </td>
          <td className="border p-2">आई०सी०डी०एस०</td>
          <td className="border p-2"></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
        {/* BENEFITS / ELIGIBILITY / PROCESS */}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          <div className="bg-white p-6 shadow-md rounded-lg border-t-4 border-indigo-500 hover:shadow-lg transition">
            <h3 className="font-bold mb-2 text-indigo-700">पात्रता</h3>
            <p className="text-gray-700">
              भोजपुर जिले अन्तर्गत संस्थागत प्रसव से जन्म लेने वाली कन्या शिशु
            </p>
          </div>

          <div className="bg-white p-6 shadow-md rounded-lg border-t-4 border-green-500 hover:shadow-lg transition">
            <h3 className="font-bold mb-2 text-green-700">लाभ</h3>
            <p className="text-gray-700">
              आर्थिक, समाजिक सहायता एवम् कन्या शिशु के परिवार को सम्मान
            </p>
          </div>

          <div className="bg-white p-6 shadow-md rounded-lg border-t-4 border-orange-500 hover:shadow-lg transition">
            <h3 className="font-bold mb-2 text-orange-700">आवेदन प्रक्रिया</h3>
            <p className="text-gray-700">
              आंगनवाड़ी / अस्पताल के माध्यम से आवेदन किया जा सकता है
            </p>
          </div>
        </div>

        {/* LIVE DASHBOARD */}

        <div className="bg-white shadow-lg rounded-lg p-6 mb-10 border-t-4 border-indigo-600">
          {/* LIVE DASHBOARD */}

          <div className="bg-white shadow rounded p-6 mb-10">
            <h2 className="text-2xl font-bold mb-4 text-indigo-700">
              जिला योजना डैशबोर्ड (कुल लाभार्थी)
            </h2>

            <p className="mb-4">
              कुल लाभार्थी:
              <span className="font-bold text-green-600 ml-2">
                {totalBeneficiaries}
              </span>
            </p>

            {loading ? (
              <p>Loading data...</p>
            ) : (
              <DistrictDrilldownChart setTotalBeneficiaries={setTotalBeneficiaries} />
            )}
          </div>
        </div>

        {/* FAQ SECTION */}

        <div className="bg-white shadow-lg rounded-lg p-6 mb-10 border-t-4 border-indigo-600">
          <h2 className="text-2xl font-bold mb-6">
            Frequently Asked Questions
          </h2>

          {faqData.map((item, index) => (
            <div key={index} className="border-b py-3">
              <button
                onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                className="w-full text-left font-semibold flex justify-between text-indigo-700"
              >
                {item.question}

                <span>{openFAQ === index ? "-" : "+"}</span>
              </button>

              {openFAQ === index && (
                <p className="text-gray-600 mt-2">{item.answer}</p>
              )}
            </div>
          ))}
        </div>

        {/* CHATBOT */}

        <Chatbot />
      </div>

      {/* FOOTER */}
    </div>
  );
}
